'use client';

import React from 'react';
import Layout from '../../components/Layout';
import SubDocsLayout from '../../components/SubDocsLayout';
import SEOHead from '../../components/SEOHead';
import useTranslation from 'next-translate/useTranslation';
import { useTheme } from '../../lib/ThemeContext';

const FAQ = () => {
  const { lang } = useTranslation('common');
  const { theme } = useTheme();
  const isLt = lang === 'lt';
  const isDarkTheme = theme === 'dark';

  const questions = isLt
    ? [
        {
          q: 'Kiek laiko trunka užsakymo pristatymas Europoje?',
          a: 'Dauguma užsakymų pristatomi per 7–15 darbo dienų. Tikslus terminas priklauso nuo prekės, tiekėjo vietos ir šalies, į kurią pristatoma.',
        },
        {
          q: 'Ar gausiu siuntos sekimo numerį?',
          a: 'Taip. Kai užsakymas išsiunčiamas, atsiunčiame sekimo numerį el. paštu. Sekimo informacija gali atsinaujinti per 24–72 val.',
        },
        {
          q: 'Ar galiu atšaukti užsakymą?',
          a: 'Užsakymą galima atšaukti, jei jis dar neperduotas vykdymui. Jei užsakymas jau išsiųstas, taikoma grąžinimo procedūra pagal ES vartotojų teises.',
        },
        {
          q: 'Ką daryti, jei gavau brokuotą ar ne tą prekę?',
          a: 'Susisiekite su mumis per 48 val. nuo gavimo ir pateikite nuotraukas. Pasiūlysime pakeitimą, dalinį ar pilną pinigų grąžinimą pagal situaciją.',
        },
        {
          q: 'Ar taikomi muitai ir importo mokesčiai?',
          a: 'ES viduje daugumai užsakymų papildomi muitai netaikomi. Jei atsiranda papildomi mokesčiai, tai aiškiai nurodoma prieš apmokėjimą.',
        },
        {
          q: 'Per kiek laiko grąžinami pinigai?',
          a: 'Patvirtinus grąžinimą, pinigai paprastai grąžinami per 5–10 darbo dienų į tą pačią mokėjimo priemonę.',
        },
      ]
    : [
        {
          q: 'How long does delivery take across Europe?',
          a: 'Most orders arrive within 7–15 business days. Final timing depends on the product, supplier location, and destination country.',
        },
        {
          q: 'Will I get a tracking number?',
          a: 'Yes. Once your order is dispatched, we send a tracking number by email. Tracking updates may take 24–72 hours to appear.',
        },
        {
          q: 'Can I cancel my order?',
          a: 'You can cancel while the order has not entered fulfillment. If it has already shipped, returns and withdrawal rules apply under EU consumer law.',
        },
        {
          q: 'What if I receive a damaged or wrong item?',
          a: 'Contact us within 48 hours of delivery with photos. We will offer a replacement, partial refund, or full refund depending on the case.',
        },
        {
          q: 'Are customs or import fees charged?',
          a: 'For most EU deliveries, additional customs charges do not apply. If any extra charge may apply, it is disclosed before checkout.',
        },
        {
          q: 'How long do refunds take?',
          a: 'After return approval, refunds are usually processed within 5–10 business days to the original payment method.',
        },
      ];

  return (
    <Layout>
      <SEOHead
        title={isLt ? 'DUK | GadgetFever' : 'FAQ | GadgetFever'}
        description={
          isLt
            ? 'Dažniausiai užduodami klausimai apie GadgetFever užsakymus, pristatymą, grąžinimus ir mokėjimus Europoje.'
            : 'Frequently asked questions about GadgetFever orders, shipping, returns, and payments across Europe.'
        }
        keywords='faq, dropshipping, ecommerce, orders, shipping, returns, europe, gadgetfever'
        canonicalUrl={isLt ? '/lt/sub/duk' : '/sub/faq'}
        lang={lang}
      />

      <SubDocsLayout>
        <h1 className={`text-2xl sm:text-3xl font-semibold mb-10 text-left ${isDarkTheme ? 'text-gray-100' : 'text-gray-900'}`}>
          {isLt ? 'Dažniausiai užduodami klausimai' : 'Frequently Asked Questions'}
        </h1>

        <div className='space-y-8'>
          {questions.map((item) => (
            <div key={item.q}>
              <h2 className={`font-semibold mb-2 ${isDarkTheme ? 'text-gray-100' : 'text-gray-900'}`}>
                {item.q}
              </h2>
              <p className={`text-sm leading-relaxed ${isDarkTheme ? 'text-gray-300' : 'text-gray-700'}`}>
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </SubDocsLayout>
    </Layout>
  );
};

export default FAQ;
